import Baixar from '@/screens/portal/publico/Baixar'
import CentralInteressado from '@/screens/portal/publico/CentralInteressado'
import DocumentosCadastro from '@/screens/portal/publico/components/informacao/DocumentosCadastro'
import ManualUsuario from '@/screens/portal/publico/ManualUsuario'
import PerguntasFrequentes from '@/screens/portal/publico/components/informacao/PerguntasFrequentes'
import ObservacoesImportantes from '@/screens/portal/publico/components/informacao/ObservacoesImportantes'
import ModelosDocumentos from '@/screens/portal/publico/components/informacao/ModelosDocumentos'
import ConsultaAutenticidade from '@/screens/portal/publico/ConsultaAutenticidade'
import ConsultaGeral from '@/screens/portal/publico/ConsultaGeral'
import Transparencia from '@/screens/portal/publico/Transparencia'
import SimularVtn from '@/screens/portal/publico/SimularVtn.vue'
import PortariaHomologacao from '@/screens/portal/publico/PortariaHomologacao'
import Publicacao from '@/screens/portal/publico/Publicacao'

import ConsultaLegislacao from '@/screens/portal/publico/ConsultaLegislacao'
import DetalhesConsulta from '@/screens/portal/publico/DetalhesConsulta'
import Enviar from '@/screens/portal/publico/Enviar'
import Home from '@/screens/portal/publico/Home'
import Informacao from '@/screens/portal/publico/Informacao'
import MainPage from '@/screens/portal/publico/MainPage'
import Exportacao from '@/screens/portal/publico/components/Exportacao.vue'
import VisualizarProcesso from '@/screens/portal/publico/VisualizarProcesso'
import AcervoFundiario from '@/screens/portal/publico/AcervoFundiario'
import ListagemCredenciados from '@/screens/portal/publico/components/informacao/ListagemCredenciados'
import DownloadDocumento from '../../screens/portal/publico/DownloadDocumento.vue'

const publico = [
  {
    path: '/visualizarProcesso',
    name: '/visualizarProcesso',
    component: VisualizarProcesso,
    meta: { isPublic: false }
  },
  {
    path: '/',
    redirect: '/publico/home',
    meta: { isPublic: true }
  },
  {
    path: '/autenticidade/:tipoDocumento/:protocolo',
    redirect: '/publico/autenticidade/:tipoDocumento/:protocolo',
    meta: { isPublic: true }
  },
  {
    path: '/publico/',
    component: MainPage,
    meta: {
      isPublic: true,
      title: 'SiCARF'
    },
    children: [
      {
        path: 'home',
        name: 'home',
        component: Home,
        meta: { isPublic: true }
      },
      {
        path: 'baixar',
        name: 'baixar',
        component: Baixar,
        meta: { isPublic: true }
      },
      {
        path: 'enviar',
        name: 'enviar',
        component: Enviar,
        meta: { isPublic: true }
      },
      {
        path: 'central',
        name: 'central',
        component: CentralInteressado,
        meta: { isPublic: true }
      },
      {
        path: 'informacao',
        name: 'informacao',
        component: Informacao,
        meta: { isPublic: true },
        children: [
          {
            path: 'duvidasFrequentes',
            name: 'duvidasFrequentes',
            component: PerguntasFrequentes,
            meta: {
              menu: 'duvidasFrequentes',
              title: 'Duvidas Frequentes',
              isPublic: true
            }
          },
          {
            path: 'documentosCadastro',
            name: 'documentosCadastro',
            component: DocumentosCadastro,
            meta: {
              menu: 'documentosCadastro',
              title: 'Documentos necessários (cadastros)',
              isPublic: true
            }
          },
          {
            path: 'observacoesImportantes',
            name: 'observacoesImportantes',
            component: ObservacoesImportantes,
            meta: {
              menu: 'observacoesImportantes',
              title: 'Observações Importantes',
              isPublic: true
            }
          },
          {
            path: 'credenciadosListagem',
            name: 'credenciadosListagem',
            component: ListagemCredenciados,
            meta: {
              menu: 'credenciadosListagem',
              title: 'Credenciados',
              isPublic: true
            }
          },
          {
            path: 'modelosDocumentos',
            name: 'modelosDocumentos',
            component: ModelosDocumentos,
            meta: {
              menu: 'modelosDocumentos',
              title: 'Modelos de documentos',
              isPublic: true
            }
          }
        ]
      },
      {
        path: 'manualUsuario',
        name: 'manualUsuario',
        component: ManualUsuario,
        meta: { isPublic: true }
      },
      {
        path: 'simularVtn',
        name: 'simularVtn',
        component: SimularVtn,
        meta: { isPublic: true }
      },
      {
        path: 'geral',
        name: 'geral',
        component: ConsultaGeral,
        meta: { isPublic: true }
      },
      {
        path: 'transparencia',
        name: 'transparencia',
        component: Transparencia,
        meta: { isPublic: true }
      },
      {
        path: 'portariaHomologacao',
        name: 'portariaHomologacao',
        component: PortariaHomologacao,
        meta: { isPublic: true }
      },
      {
        path: 'publicacao',
        name: 'publicacao',
        component: Publicacao,
        meta: { isPublic: true }
      },
      {
        path: 'consultaLegislacao',
        name: 'consultaLegislacao',
        component: ConsultaLegislacao,
        meta: { isPublic: true }
      },
      {
        path: 'exportacao',
        name: 'exportacao',
        component: Exportacao,
        meta: { isPublic: true }
      },
      {
        path: 'autenticidade',
        name: 'autenticidade',
        component: ConsultaAutenticidade,
        meta: { isPublic: true },
        children: [
          {
            path: ':tipoDocumento/:protocolo',
            name: 'detalhesConsulta',
            props: true,
            component: DetalhesConsulta,
            meta: {
              isPublic: true
            }
          }
        ]
      },
      {
        path: 'downloadDocumento/:tipoDocumento/:idProcesso',
        name: 'downloadDocumento',
        component: DownloadDocumento,
        meta: { isPublic: true }
      },
      {
        path: 'acervoFundiario',
        name: 'acervoFundiario',
        component: AcervoFundiario,
        meta: { isPublic: true }
      }
    ]
  },
  {
    path: '*',
    redirect: '/publico/home',
    meta: { isPublic: true }
  }
]

export default publico



// WEBPACK FOOTER //
// ./src/router/portal/publico.js